module.exports = __webpack_public_path__ + "img/icon_01.594aa20f.png";